exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-input[data-v-00ae3b4d]{min-width:200px;width:100%}", ""]);

// exports
